import { EDIT_BOOKING_SET_VALUES, EDIT_BOOKING_ERROR_STORE_LIST, EDIT_BOOKING_SET_STORE_LIST, EDIT_BOOKING_START_STORE_LIST, EDIT_BOOKING_START_GET_INFO_BOOKING, EDIT_BOOKING_SET_BOOKING_INFO, EDIT_BOOKING_ERROR_GET_INFO_BOOKING, EDIT_BOOKING_SELECT_STORE, EDIT_BOOKING_SET_STEP, EDIT_BOOKING_RESET } from "../actions/editBooking"
import { EDIT_BOOKING_STEPS } from "../../constants";

const storeListState = {
    isRequestingStoresList: false,
    hasErrorStoresListRequest: false,
    storesList: [],
};

const dynamicState = {
    editBookingCurrentStep: EDIT_BOOKING_STEPS.SHOW_BOOKING,
    bookingCode: null,
    restaurantName: null,

    selectedStore: null,

    isRequestingBookingInfo: true,
    hasErrorRequestBookingInfo: false,
    bookingInfo: null,
}

const defaultState = {
    ...storeListState, ...dynamicState
}

export const editBookingState = (state = defaultState, action) => {
    switch (action.type) {
        case EDIT_BOOKING_SET_VALUES: return { ...state, bookingCode: action.bookingCode, restaurantName: action.restaurantName }

        // Store list
        case EDIT_BOOKING_SELECT_STORE: return { ...state, selectedStore: action.store }
        case EDIT_BOOKING_START_STORE_LIST: return { ...state, isRequestingStoresList: true, hasErrorStoresListRequest: false, storesList: [] }
        case EDIT_BOOKING_ERROR_STORE_LIST: return { ...state, isRequestingStoresList: false, hasErrorStoresListRequest: true, storesList: [] }
        case EDIT_BOOKING_SET_STORE_LIST: return { ...state, isRequestingStoresList: false, hasErrorStoresListRequest: false, storesList: action.stores }

        // Booking info
        case EDIT_BOOKING_START_GET_INFO_BOOKING: return { 
            ...state, 
            isRequestingBookingInfo: true, 
            hasErrorRequestBookingInfo: false, 
            bookingInfo: null 
        }
        case EDIT_BOOKING_ERROR_GET_INFO_BOOKING: return {
            ...state,
            isRequestingBookingInfo: false,
            hasErrorRequestBookingInfo: true,
            bookingInfo: null
        }
        case EDIT_BOOKING_SET_BOOKING_INFO: return {
            ...state,
            isRequestingBookingInfo: false,
            hasErrorRequestBookingInfo: false,
            bookingInfo: action.booking,
        }
        case EDIT_BOOKING_SET_STEP: return {
            ...state, editBookingCurrentStep: action.editStep
        }

        case EDIT_BOOKING_RESET: return {
            ...state, ...dynamicState
        }
        default: return state
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/editBooking.js